export const handleBalanceKeyDown = (e) => {
  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
    return;
  }

  if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) {
    return;
  }

  if (!/^[0-9.-]$/.test(e.key)) {
    e.preventDefault();
    return;
  }

  const input = e.target.value;
  if (e.key === '.' && input.includes('.')) {
    e.preventDefault();
    return;
  }

  if (e.key === '-' && (input.includes('-') || input.length > 0)) {
    e.preventDefault();
    return;
  }
};

export const formatBalanceValue = (value) => {
  if (value === null || value === undefined || value === '') return '';
  
  const stringValue = value.toString().trim();
  
  if (stringValue === '.') return '';
  
  let numValue = parseFloat(stringValue);
  
  if (isNaN(numValue)) return stringValue;
  
  if (numValue > 99.99) {
    return "99.99";
  }
  
  if (stringValue.includes('.') && stringValue.split('.')[1] && stringValue.split('.')[1].length > 2) {
    return numValue.toFixed(2);
  }
  
  return stringValue;
}; 